import Item from "./Item";
import Tenant from "./Tenant";

export default class ItemImage{
  constructor(
    public id: number,
    public tenant: Tenant,
    public item: Item,
    public imageTypeCode: string,
    public imageDataType: string,
    public binaryContent: string
  ) {}
}